export type ConnectAppStack = 'merge' | 'nango';

/** Default file connectors when the agent omits ``options`` (Merge slugs). */
export const DEFAULT_CONNECT_APP_CONNECTORS_MERGE = [
  'google_drive',
  'dropbox',
  'box',
  'onedrive',
  'sharepoint',
] as const;

/** Default file providers when the agent omits ``options`` (Nango keys). */
export const DEFAULT_CONNECT_APP_CONNECTORS_NANGO = [
  'google-drive',
  'one-drive',
  'sharepoint-online',
] as const;

export interface ConnectAppOption {
  id: string;
  label?: string;
  /** Nango key for OAuth when `id` is the option the agent offered. */
  providerKey?: string;
}
